import {
	Card,
	Col,
	message,
	Row,
	Tag,
	Typography,
	Statistic,
	Progress,
	Button,
	Badge,
	DatePicker,
	Select,
	Space,
	Tooltip,
} from "antd";
import { useContext, useEffect, useState } from "react";
import SearchInput from "../../components/SearchInput";
import { useNavigate, useParams } from "react-router";
import AppContext from "../../store/app.context";
import { requestGetUserList } from "../../services/admin.service";
import dayjs from "dayjs";
import { formatCurrency } from "../../utils/Formatter";

function DashboardPage() {
	const context = useContext(AppContext);
	const navigate = useNavigate();
	const user = context.user;

	// set document title
	useEffect(() => {
		document.title = "Shopiva Console | Dashboard";
	}, []);

	function checkMatch(input, searchTerm) {
		const regex = new RegExp(searchTerm.split("").join(".*?"), "gi");
		return regex.test(input);
	}

	const handleSearch = (value) => {};

	const handleGroupFilter = (groupId) => {};

	const getStatusColor = (status) => {
		switch (status) {
			case "success":
				return "#52c41a";
			case "warning":
				return "#faad14";
			case "error":
				return "#f5222d";
			default:
				return "#1890ff";
		}
	};

	return <div></div>;
}

export default DashboardPage;
